import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54b042b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "t-test-result-multifacet" }
const _hoisted_2 = { class: "t-test-result-multifacet__content" }
const _hoisted_3 = { class: "container py-5 mt-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t-test-result-multifacet__content-assesment-label" }, " Asesmen ", -1))
const _hoisted_7 = { class: "t-test-result-multifacet__content-assesment-value" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t-test-result-multifacet__content-assesment-label" }, " Kamu termasuk tipe ", -1))
const _hoisted_11 = { class: "t-test-result-multifacet__content-highlight" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"200px","height":"2px","background":"#f3f3f3","margin":"32px auto 0"} }, null, -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "d-flex justify-content-center justify-content-lg-center mb-3" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_18 = { class: "name d-flex flex-column" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "score" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Unduh laporan", -1))
const _hoisted_22 = { class: "description mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Unduh laporan", -1))
const _hoisted_24 = { class: "grid-container" }
const _hoisted_25 = ["src", "onClick"]
const _hoisted_26 = { class: "grid-number" }
const _hoisted_27 = { class: "grid-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BImg = _resolveComponent("BImg")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "t-test-result-multifacet__link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/home')))
            }, [
              _createVNode(_component_FontAwesomeIcon, {
                class: "ml-2",
                icon: "chevron-left"
              }),
              _createTextVNode(" Kembali ke dashboard ")
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.detailTestResult.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.detailTestResult.highlight), 1),
            _createElementVNode("div", {
              class: "t-test-result-multifacet__content-assesment-description",
              innerHTML: _ctx.detailTestResult.description
            }, null, 8, _hoisted_12)
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_BModal, {
              id: "modal-result-detail",
              modelValue: _ctx.modal.isShow,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modal.isShow) = $event)),
              size: "lg",
              "hide-footer": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_BImg, {
                      src: _ctx.modal.image,
                      width: "200",
                      height: "200",
                      rounded: "circle",
                      fluid: ""
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.modal.name), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.modal.score) + "%", 1)
                    ]),
                    _createVNode(_component_BButton, {
                      class: "d-none d-lg-block",
                      variant: "warning",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadResultFile(_ctx.modal.file)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21,
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "ml-2",
                          icon: "download"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.modal.description), 1),
                  _createVNode(_component_BButton, {
                    class: "d-lg-none",
                    variant: "warning",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadResultFile(_ctx.modal.file)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23,
                      _createVNode(_component_FontAwesomeIcon, {
                        class: "ml-2",
                        icon: "download"
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailTestResult.user_results, (userResult, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "grid-result",
                  key: i
                }, [
                  _createElementVNode("img", {
                    src: userResult.image,
                    width: "72",
                    height: "72",
                    class: "grid-img rounded-circle",
                    role: "button",
                    onClick: ($event: any) => (_ctx.showResultDetail(userResult))
                  }, null, 8, _hoisted_25),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(userResult.score) + "%", 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(userResult.name), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}